import React from 'react';
import { CacheManager, flushAPICache, statsAPICache } from './counterAPI';


//SwitchURLs
const handleSwitchClick = (e)=>{
    e.preventDefault()
    let dartURLState= localStorage.getItem("darturl");
    if(parseInt(dartURLState)===1){
        localStorage.setItem("darturl",0)
        alert("MPS URLs set. Click any TOC link to see link update in address bar");
    }else{
        localStorage.setItem("darturl",1)
        alert("New URL format set. Click any TOC link to see link update in address bar");
    }
}
export const SwitchURLs = (props)=>{

    return(
    <a href="Toggle_url_format" title="Toggle D@RT/MPS urls" onClick={(e)=>handleSwitchClick(e)}>U</a>
    )
}


//ToggleTNFDisplay
const handleTNFClick = (e)=>{
    e.preventDefault()
    let tnfState = localStorage.getItem("tnf");
    if(tnfState===null){
        localStorage.setItem("tnf","show");
        alert("Show T and F inline set. Click any TOC link to see T and F links");
    }else{
        localStorage.removeItem('tnf');
        alert("Removed T and F inline. Click any TOC link to hide T and F links");
    }
}
export const ToggleTNFDisplay = (props)=>{

    return(
    <a href="Toggle_url_format" title="Toggle Tables and figures link display in line" onClick={(e)=>handleTNFClick(e)}>TF</a>
    )
}


//ExitDart
const handleExitClick = (e)=>{
    try {e.preventDefault()} catch (error) {}
    localStorage.removeItem('dart');
    alert("D@RT stopped. Click ok to refresh  page");
    window.location.reload();
}
export const ExitDart = (props)=>{

    return(
    <a href="Toggle_url_format" title="eXit D@RT" onClick={(e)=>handleExitClick(e)}>X</a>
    )
}
if(window.location.href.indexOf("#stopdart")>-1){handleExitClick("")}


//LocalDart
const handleLocalClick = (e)=>{
    e.preventDefault()
    let devState= localStorage.getItem("dev");
    if(devState===null){
        localStorage.setItem("dev",true);
        alert("Dev mode set. Click ok to refresh page");
    }else{
        localStorage.removeItem('dev');
        alert("Removed dev mode. Click ok to refresh page");
    }
    window.location.reload();
}
export const LocalDart = (props)=>{
//requires localhost/iis hosts file setup for https://cdn.ckeditor.com/ pointing to build folder
    return(
    <a href="Toggle_url_format" title="Dart from localhost" onClick={(e)=>handleLocalClick(e)}>L</a>
    )
}


//LocalDart
const handleBigFileClick = (e)=>{
    e.preventDefault()
    let dartBigFile= localStorage.getItem("dartbig");
    if(dartBigFile===null){
        localStorage.setItem("dartbig",true);
        alert("Big File set. Click ok to refresh page");
    }else{
        localStorage.removeItem('dartbig');
        alert("Removed Big File. Click ok to refresh page");
    }
    window.location.reload();
}
export const BigFile = (props)=>{
    return(
    <a href="Toggle_url_format" title="Toggle Large/Min File" onClick={(e)=>handleBigFileClick(e)}>B</a>
    )
}

//ClearIDB
const handleClearClick = (e)=>{
    e.preventDefault()
    const iDB = new CacheManager();
    iDB.clear().then(()=>{
        console.log("iDB cleared for main")
        alert("Cache cleared. Click ok to refresh page");
        window.location.reload();
    });
}
export const ClearIDB = (props)=>{
    //requires localhost/iis hosts file setup for https://cdn.ckeditor.com/ pointing to build folder
        return(
        <a href="Toggle_url_format" title="Clear Cache" onClick={(e)=>handleClearClick(e)}>C</a>
        )
    }


//FlushAPI
const handleFlushClick = (e)=>{
    e.preventDefault()
    const catchFlush = flushAPICache();
    return catchFlush;
}
export const FlushAPI = (props)=>{
    return(
    <a href="Toggle_url_format" title="Flush API Cache" onClick={(e)=>handleFlushClick(e)}>F</a>
    )
}



//APICacheStats
const handleAPIStatsClick = (e)=>{
    e.preventDefault()
    const catchStats = statsAPICache();
    return catchStats;
}
export const APICacheStats = (props)=>{
    return(
    <a href="Toggle_url_format" title="API Cache Stats" onClick={(e)=>handleAPIStatsClick(e)}>S</a>
    )
}


//APICacheStats
const handleLocalTOC = (e)=>{
    e.preventDefault()
    let localTOC= localStorage.getItem("localtoc");
    if(localTOC===null){
        localStorage.setItem("localtoc",true);
        alert("Local TOC set. Click ok to refresh page");
    }else{
        localStorage.removeItem('localtoc');
        alert("Removed Local TOC. Click ok to refresh page");
    }
    window.location.reload();
}
export const LocalTOC = (props)=>{
    return(
    <a href="Toggle_local_toc" title="Local toc for RnD. Requires IIS config" onClick={(e)=>handleLocalTOC(e)}>TX</a>
    )
}